import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

// Definisci i nomi dei temi disponibili
const THEMES = {
  LIGHT: "light",     // Default: Viola/Blu
  DARK: "dark",       // Dark mode
  // ==========================================
  // TEMA NATALIZIO ARCHIVIATO
  // Per riattivare: decommentare la riga seguente
  // ==========================================
  // CHRISTMAS: "christmas", // Tema natalizio
};

const ThemeContext = createContext({
  theme: THEMES.LIGHT,
  toggleTheme: () => {},
  setTheme: () => {},
});

export function ThemeProvider({ children }) {
  // Leggi il tema salvato da localStorage o usa il default
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("appTheme");
    return savedTheme && Object.values(THEMES).includes(savedTheme)
      ? savedTheme
      : THEMES.LIGHT;
  });

  // Applica la classe del tema al body quando il tema cambia
  useEffect(() => {
    const bodyClassList = document.body.classList;
    // Rimuovi classi di temi precedenti
    Object.values(THEMES).forEach(t => bodyClassList.remove(t));
    // Aggiungi la classe del tema corrente
    bodyClassList.add(theme);
    
    // Salva il tema in localStorage
    localStorage.setItem("appTheme", theme);
  }, [theme]);

  // Funzione per cambiare tema (cicla tra light e dark)
  // ==========================================
  // TEMA NATALIZIO ARCHIVIATO
  // Per riattivare: sostituire questo toggleTheme con:
  //   const toggleTheme = useCallback(() => {
  //     setTheme((prevTheme) => {
  //       if (prevTheme === THEMES.LIGHT) return THEMES.DARK;
  //       if (prevTheme === THEMES.DARK) return THEMES.CHRISTMAS;
  //       return THEMES.LIGHT;
  //     });
  //   }, []);
  // ==========================================
  const toggleTheme = useCallback(() => {
    setTheme((prevTheme) => {
      if (prevTheme === THEMES.LIGHT) return THEMES.DARK;
      return THEMES.LIGHT;
    });
  }, []);

  // Funzione per impostare un tema specifico
  const setThemeDirectly = useCallback((newTheme) => {
    if (Object.values(THEMES).includes(newTheme)) {
      setTheme(newTheme);
    }
  }, []);

  const value = { theme, toggleTheme, setTheme: setThemeDirectly, THEMES };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}